import { DEFAULT_CURRENT_STATUS_SEARCH } from "./CurrentStatusSearch";
import i18next from "i18next";
import { html } from "lit-html";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
import { useEffectWithoutCleanup } from "Shared/haunted/CustomHooks";
import { useReduxState } from "Shared/redux/useReduxState";
import { iconButton } from "Components/iconButton";
import { DynamicSettings } from "Components/admin/DynamicSettings";

interface Props {
	culture: string;
	dynamicSettings: DynamicSettings;
	isActive: boolean;
	isUsingAmericanMiles: boolean;
}

export const useFlightStatusTab = (props: Props) => {
	const [, setCurrentStatusSearch] = useReduxState("currentStatusSearch");
	const [kontent] = useReduxState("kontent.flightStatus.flightStatusTest");

	const handleSubmit = () => {
		const [language, country] = props.culture.split("-");
		window.location.href = `https://jetsmart.com/${country}/${language}/estado-de-vuelo`;
	};

	const button = iconButton({
		isAction: true,
		icon: html`<i class="jsh-circle-chevron-right1 text-base"></i>`,
		label: i18next.t("Ver estado de tu vuelo"),
		onClick: handleSubmit,
	});

	useEffectWithoutCleanup(() => {
		setCurrentStatusSearch(DEFAULT_CURRENT_STATUS_SEARCH);
	}, [props.isActive]);

	const htmlTemplate = () => html`
		<div class="flex flex-col gap-4 sm:p-8">
			<div class="text-xl leading-6 text-n-blue sm:text-[28px]">${unsafeHTML(kontent.contents.title.value)}</div>

			<div class="flex gap-4 rounded-lg bg-[#F0F3F7] p-2 text-sm/5 text-n-blue">
				<div class="mr-4 text-[40px]/none">${unsafeHTML(kontent.contents.searchboxIcon.value)}</div>
				<div class="text-sm">${unsafeHTML(kontent.contents.text.value)}</div>
			</div>

			<div class="flex w-full justify-end">${button.htmlTemplate()}</div>
		</div>
	`;

	return { htmlTemplate };
};
